import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";

export default function StepNextOfKinAndBank({ data, update }) {
  const {
    NOKname,
    NOKsurname,
    NOKPhone,
    bankName,
    shortCode,
    bankAcc,
  } = data;

  return (
    <Box component="section" className="nsp_step">
      <Typography variant="h6" sx={{ mt: 1 }}>
        Next of kin details
      </Typography>
      <Divider sx={{ mb: 2 }} />

      <TextField
        id="NOKname"
        label="Name"
        required
        placeholder="First Name"
        inputProps={{ maxLength: 75 }}
        value={NOKname}
        onChange={(e) => update("NOKname", e.target.value)}
        sx={{ mb: 2 }}
      />
      <TextField
        id="NOKsurname"
        label="Last Name"
        required
        placeholder="Surname"
        inputProps={{ maxLength: 75 }}
        value={NOKsurname}
        onChange={(e) => update("NOKsurname", e.target.value)}
        sx={{ mb: 2 }}
      />
      <TextField
        id="NOKPhone"
        label="Phone Number"
        required
        placeholder="Phone Number"
        inputProps={{ maxLength: 11, inputMode: "tel" }}
        value={(NOKPhone || "").replace(/\D/g, "")}
        onChange={(e) => update("NOKPhone", e.target.value.replace(/\D/g, "").slice(0, 11))}
        sx={{ mb: 3 }}
      />

      <Typography variant="h6">Bank Details</Typography>
      <Divider sx={{ mb: 2 }} />

      <TextField
        id="bankName"
        label="Bank Name"
        required
        placeholder="Bank Name"
        inputProps={{ maxLength: 75 }}
        value={bankName}
        onChange={(e) => update("bankName", e.target.value)}
        sx={{ mb: 2 }}
      />
      <TextField
        id="ShortCode"
        label="Sort Code"
        required
        helperText="format: 123456"
        placeholder="Sort Code"
        inputProps={{ maxLength: 6, inputMode: "numeric" }}
        value={(shortCode || "").replace(/\D/g, "")}
        onChange={(e) => update("shortCode", e.target.value.replace(/\D/g, "").slice(0, 6))}
        sx={{ mb: 2 }}
      />
      <TextField
        id="bankAcc"
        label="Account Number"
        required
        helperText="format: 12345678"
        placeholder="Account Number"
        inputProps={{ maxLength: 8, inputMode: "numeric" }}
        value={(bankAcc || "").replace(/\D/g, "")}
        onChange={(e) => update("bankAcc", e.target.value.replace(/\D/g, "").slice(0, 8))}
        sx={{ mb: 2 }}
      />
    </Box>
  );
}
